var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Button, Modal } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { Feature } from "./Feature";
import { useFeatures } from ".";
import { useCustomerAction, useModal } from "@/hooks";
import { InteractionEnum } from "@/types";
import { ModalIds } from "@/constants";
import { formatTextWithHtml } from "@/utils";
import { MAX_FEATURES_PREVIEW_COUNT } from "./constants";
import { useTrackingShowMore } from "@/hooks/tracking/useTrackingShowMore";
export const FeaturesDetails = () => {
    const { t } = useI18n();
    const features = useFeatures();
    const { isOpen, open, toggle } = useModal(false, ModalIds.FEATURES);
    const { customerActionLeadInteraction } = useCustomerAction();
    const title = t("features.title");
    const handleTrackingShowMore = useTrackingShowMore("classified_feature_details");
    if (!features)
        return null;
    const { categories, additionalText, buttonLabel, detailsCount } = features;
    if (detailsCount === 0)
        return null;
    if (detailsCount <= MAX_FEATURES_PREVIEW_COUNT)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Box, { unsafe_className: "HideOnPrint", children: _jsx(Button, { variant: "secondary", marginTop: "spacing.8", isFullWidth: {
                        "breakpoint.base": true,
                        "breakpoint.sm": false,
                    }, onPress: () => __awaiter(void 0, void 0, void 0, function* () {
                        yield customerActionLeadInteraction(InteractionEnum.OPEN_MORE, title);
                        handleTrackingShowMore();
                        open();
                    }), children: buttonLabel }) }), _jsx(Modal, { title: title, titleAs: "h2", isDismissable: true, trigger: () => null, isOpen: isOpen, onOpenChange: toggle, children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.40", children: [categories === null || categories === void 0 ? void 0 : categories.map((category) => (_jsxs(Box, { display: "grid", gridTemplateColumns: "repeat(1, 1fr)", rowGap: "spacing.24", as: "ul", paddingLeft: "spacing.none", marginVertical: "spacing.none", children: [_jsx(Box, { as: "h3", typography: "typography.headline.22.bold", marginVertical: "spacing.none", children: category.title }), category.elements.map((feature) => (_jsx(Box, { as: "li", unsafe_style: { listStyleType: "none" }, children: _jsx(Feature, { feature: feature }) }, feature.value)))] }, category.title))), additionalText && (_jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.16", children: [_jsx(Box, { as: "span", typography: "typography.headline.22.bold", children: t("features.category.additional_information") }), _jsx(Box, { as: "p", marginVertical: 0, dangerouslySetInnerHTML: {
                                        __html: formatTextWithHtml(additionalText),
                                    } })] }))] }) })] }));
};
